import styled from "@emotion/styled";

export const StatusHeader = styled.h2(props => props.theme.candy.typography.header4.css());
